import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import {
  clampProgressIndex,
  normalizeActivityProgressStatus,
} from '../../utilities/activitySelection';

/**
 * Pure presentation of one plan activity. Progress arrives via the planner
 * data (the server mirrors aggregate progress into the planner doc, and
 * PlannerContext merges live event-bus updates into it) — the card itself
 * never fetches.
 */
function ActivityCard({
  activityId,
  title,
  description,
  progress = null,
  onActivityClick,
  className = ""
}) {
  const status = normalizeActivityProgressStatus(
    progress?.status,
    clampProgressIndex(progress?.progressIndex)
  );

  const progressIcon = status === 'completed'
    ? faCheckCircle
    : status === 'in_progress'
      ? faRotateRight
      : null;

  const handleClick = () => {
    onActivityClick(`learning-path-${activityId}`);
  };

  return (
    <button
      className={`button activity treasure-activity-button grid-activity progress-${status} ${className}`}
      onClick={handleClick}
      title={description || title}
    >
      <div className="activity-item">
        <div className="activity-number">
          {activityId}
        </div>
        {progressIcon && (
          <div className="activity-progress-icon">
            <FontAwesomeIcon icon={progressIcon} />
          </div>
        )}
        <div className="activity-title">
          {title}
        </div>
      </div>
    </button>
  );
}

export default ActivityCard;
